import { CreateReviewPayload, ReviewResponse, updateTeamsPayload } from '../features/review/reviewTypes';
import { del, get, post, put } from '../utils/api';
import { formatUrl } from '../utils/urlFormatter';


const fetch_review = '/{0}/reviewTemplate.list';
const create_reviews = '/{0}/reviewTemplate.add';
const update_reviews = '/{0}/{1}/reviewTemplate.update';
const fetch_review_status = '/{0}/reviewTemplate.list';
const fetch_review_details = '/{0}/{1}/reviewTemplate.detail';
const fetch_review_list_by_job = '/{0}/reviewTemplate.list'
const assign_review_template = '/{0}/{1}/{2}/reviewTemplate.assign';

const credentialsConfig = {
    withCredentials: true,
}


export const fetchReviewData = async (baseId: number): Promise<ReviewResponse> => {
    const fetch_review_data = formatUrl(fetch_review, [baseId]);
    return get<ReviewResponse>(fetch_review_data, credentialsConfig);
};

export const fetchReviewDataStatus = async (baseId: number, status?: string): Promise<ReviewResponse> => {
    let fetch_review_data = formatUrl(fetch_review_status, [baseId]);
    if (status) {
        fetch_review_data += `?status=${status}`;
    }
    return get<ReviewResponse>(fetch_review_data, credentialsConfig);
};


export const createReviewData = async (data: CreateReviewPayload, userId: number): Promise<ReviewResponse> => {
    const base_create_location = formatUrl(create_reviews, [userId]);
    return post<ReviewResponse>(base_create_location, data, credentialsConfig);
};



export const updateReviewData = async (id: number, baseId: number, data: updateTeamsPayload): Promise<ReviewResponse> => {
    const update_teams_data = formatUrl(update_reviews, [id, baseId]);
    return put<ReviewResponse>(update_teams_data, data, credentialsConfig);
};

export const fetchReviewDetails = async (baseId: number, userId: string): Promise<ReviewResponse> => {
    const fetch_pipeline_details1 = formatUrl(fetch_review_details, [baseId, userId]);
    return get<ReviewResponse>(fetch_pipeline_details1, credentialsConfig);
};

export const fetchReviewDataByJob = async (baseId: number, status?: string, jobId?: string): Promise<ReviewResponse> => {
    let fetch_review_data = formatUrl(fetch_review_list_by_job, [baseId]);
    
    // Start with a question mark for the first parameter
    if (status) {
        fetch_review_data += `?status=${status}`;
        // Add ampersand for subsequent parameters
        if (jobId) {
            fetch_review_data += `&job_id=${jobId}`;
        }
    } else if (jobId) {
        // If status is not provided but jobId is
        fetch_review_data += `?job_id=${jobId}`;
    }
    
    return get<ReviewResponse>(fetch_review_data, credentialsConfig);
};

export const assignReviewTemplateDetails = async (baseId: number,userId: string, JobId: string): Promise<ReviewResponse> => {
    const assign_job_Review = formatUrl(assign_review_template, [baseId,userId, JobId]);
    return post<ReviewResponse>(assign_job_Review, {}, credentialsConfig);
};